import { defineScreen } from "@vjal/screen-kit";
import { ProductRouteScreenAdapter } from "../pages/product-route-context";

/** ScreenModule IR authority — Component is the shared product route adapter. */

export const settings_thresholdsScreenModule = defineScreen({
  app: "coaching",
  screen_id: "settings-thresholds",
  path: "/settings/thresholds",
  heading: { text: "Thresholds & settings", level: 1 },
  roles: {
    "super_admin": "allow",
    "admin": "allow",
    "coach": "allow",
    "company_admin": "deny",
    "participant": "deny",
    "cohort_lead": "deny"
  },
  states: ["ready"],
  actions: [
    { id: "fill-valid", kind: "secondary", driver: "form.fillValid" },
    { id: "submit", kind: "primary", driver: "form.submit" },
    { id: "validation-error", kind: "secondary", driver: "form.validationError" }
  ],
  recipe: "Form-1",
  data: { seedNeeds: ["readonly-walk-session", "mutation-disposable-entity"] },
  authority: { source_ref: "apps/coaching-dashboard/src/screens/settings-thresholds.tsx" },
  Component: ProductRouteScreenAdapter,
});

export default settings_thresholdsScreenModule;
